/* eslint-disable no-catch-shadow */
/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState, useMemo } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import DBModuleHeaderLayout from 'components/Common/Layouts/DBProductsModuleHeaderLayout';
import HelpContentModal from 'components/BiteDB/Components/HelpContent';
import { helpContent } from 'components/BiteDB/common/HelpContent';
import ComplianceScoringGuidelines from 'components/BiteDB/Components/ComplianceScoringGuidelines';
import { useHistory } from 'react-router-dom';

import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import ContactsIcon from '@mui/icons-material/Contacts';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';

import BrightnessHighIcon from '@mui/icons-material/BrightnessHigh';
import { DatabaseIcon } from 'resources/img/icon/database';
import StatCard from 'components/BiteDB/NewComponents/StatCard';

import { enqueueSnackbar } from 'notistack';

import { Modal, Pagination } from '@mui/material';

import CardDB from 'components/BiteDB/Cards/CardDBProducts';
import CreateProductDatabaseModal from 'components/BiteDB/Modal/CreateProductDatabase';
import ContactsTable from 'components/BiteDB/Tables/ContactsTable';
import UploadsTable from 'components/BiteDB/Tables/UploadsTable';

import { useGetProductDbStatsByGroupId } from 'api/bitedb/stats/stats.hooks';
import { useGetDatabasesByGroupIdPagination } from '../../api/bitedb/database/database.hooks';
import {
  useDeleteProduct,
  useGetProductsByGroupId,
} from 'api/bitedb/products/products.hooks';
import { useBulkUploadEvents } from 'hooks/useSocketIO';
import SettingsIcon from '@mui/icons-material/Settings';
import MasterTable from 'components/BiteDB/Tables/MasterTable';
import { PaginationParams } from '../../api/bitedb/products/products';
import ProductColumns from 'components/BiteDB/Tables/ProductColumnsProductDB';
import ProductRow from 'components/BiteDB/Tables/ProductRowProductDB';
import DatabaseRow from 'components/BiteDB/Tables/DatabaseRow';
import DatabaseColumns from 'components/BiteDB/Tables/DatabaseColumns';
import DeleteCommonModal from 'components/Monitor/Modals/DeleteModal';
import BiteDBAPI from 'api/BiteDBAPI';
import AddProductModal from 'components/BiteDB/Modal/AddProductModal';
import Classification from 'components/BiteDB/Modal/ImportClassificationModal';
import RequiredLicense from 'pages/assign/RequiredLicense';
import { LicenseType } from 'pages/assign/LicenseBadge';
import LockIcon from '@mui/icons-material/Lock';

const ProductsComponent: React.FC = () => {
  const history = useHistory();
  const [openRules, setOpenRules] = useState(false);
  const handleCloseRules = () => setOpenRules(false);
  // User and subscrip[tion info]
  const { cur_user } = useContext(GlobalContext);
  const [userHasMonitor, setUserHasMonitor] = useState(true);

  // Subscription check (replace with actual check)
  const requiredTiers = ['business', 'enterprise'];

  const checkSubscription = async () => {
    if (cur_user.quickcodeOnly || cur_user?.bite_super_admin === true) {
      setUserHasMonitor(true);
      return;
    }
    setUserHasMonitor(requiredTiers.includes(cur_user.license));
  };

  // Initial data fetch
  useEffect(() => {
    if (cur_user.selected_team) {
      checkSubscription();
    }
  }, [cur_user.selected_team, cur_user.license, cur_user.quickcodeOnly]);

  const isInteractionDisabled = !userHasMonitor;
  const normalizedLicense = (
    ['none', 'standard', 'pro', 'business', 'enterprise'].includes(
      cur_user?.license,
    )
      ? cur_user.license
      : 'none'
  ) as LicenseType;
  const groupIdForQueries = isInteractionDisabled
    ? ''
    : cur_user?.selected_team?.id;

  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [showCreateProductDatabaseModal, setShowCreateProductDatabaseModal] =
    React.useState(false);
  const [showDatabaseSettingsModal, setShowDatabaseSettingsModal] =
    React.useState<boolean>(false);

  const [settingTab, setSettingTab] = useState('Contacts');
  const settingTabs = ['Contacts', 'Data Sources', 'Uploads'];
  const handleSettingTabChange = (newTab: string) => {
    if (settingTabs.includes(newTab)) {
      setSettingTab(newTab);
    } else if (!settingTabs.includes(settingTab)) {
      setSettingTab('Contacts');
    }
  };

  const [isTableView, setIsTableView] = useState(false);

  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<string>('');

  const page = parseInt(queryParams.get('page') || '1', 10);
  const limit = parseInt(queryParams.get('limit') || '12', 10);
  const sortBy = queryParams.get('sortBy') || 'hit_count';
  const sortOrder = (queryParams.get('sortOrder') as 'asc' | 'desc') || 'desc';
  const urlSubtype = queryParams.get('subtype') || '';
  const urlSearchTerm = queryParams.get('search') || '';
  const [localSortBy, setLocalSortBy] = useState(sortBy);
  const [localSortOrder, setLocalSortOrder] = useState(sortOrder);
  const [localLimit] = useState(limit);
  const [localSubtype] = useState(urlSubtype);
  const [localSearchTerm, setLocalSearchTerm] = useState(urlSearchTerm);
  const [currentPage, setCurrentPage] = useState(page);

  const [localProductSortBy, setLocalProductSortBy] = useState('name');
  const [localProductSortOrder, setLocalProductSortOrder] = useState<
    'asc' | 'desc'
  >('asc');
  const [localProductLimit] = useState(10);
  const [localProductSearchTerm, setLocalProductSearchTerm] = useState('');
  const [hasIssues, setHasIssues] = useState(false);
  const [currentProductPage, setCurrentProductPage] = useState(1);

  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handlePageChange = (e: any, new_page: number) => {
    setCurrentPage(new_page);
  };

  const handlePageChangeProduct = (e: any, new_page: number) => {
    setCurrentProductPage(new_page);
  };

  const [processingDatabases, setProcessingDatabases] = useState<Set<string>>(
    new Set(),
  );

  const handleDatabaseCreated = (databaseId: string) => {
    setProcessingDatabases((prev) => new Set(prev).add(databaseId));
    refetchDbs();
  };

  const handleDatabaseUploadFailed = (databaseId: string) => {
    setProcessingDatabases((prev) => {
      const updated = new Set(prev);
      updated.delete(databaseId);
      return updated;
    });
  };

  // Listen for bulk upload events via Socket.IO for global notifications
  useBulkUploadEvents(undefined, {
    onComplete: (result) => {
      if (result.databaseId) {
        setProcessingDatabases((prev) => {
          const updated = new Set(prev);
          updated.delete(result.databaseId || '');
          return updated;
        });
        refetchDbs();
        enqueueSnackbar(
          `Products uploaded successfully! ${
            result.duplicatesRemoved
              ? `${result.duplicatesRemoved} duplicates were removed.`
              : ''
          }`,
          { variant: 'success' },
        );
      }
    },
    onFailed: (result) => {
      console.error('[BiteDB] Bulk upload failed:', result);
      if (result.databaseId) {
        setProcessingDatabases((prev) => {
          const updated = new Set(prev);
          updated.delete(result.databaseId || '');
          return updated;
        });
        enqueueSnackbar(
          result.error || 'Product upload failed. Please check the database.',
          { variant: 'error' },
        );
      }
    },
  });

  const handleSort = (key: string) => {
    const newSortOrder = sortBy === key && sortOrder === 'asc' ? 'desc' : 'asc';
    setLocalSortBy(key);
    setLocalSortOrder(newSortOrder);
  };

  // Mutation hooks
  const {
    data: databases,
    isLoading: dbsLoading,
    error: dbsError,
    refetch: refetchDbs,
    pagination: dbsPagination,
  } = useGetDatabasesByGroupIdPagination(
    groupIdForQueries || '',
    localSearchTerm,
    {
      page: currentPage,
      limit: localLimit,
      sortBy: localSortBy,
      sortOrder: localSortOrder === 'asc' ? 'desc' : 'asc', // Invert sort order for API call
      type: 'products',
      subtype: localSubtype,
    },
  );

  const [isDatabaseView, setIsDatabaseView] = useState(true);
  const deleteProductMutation = useDeleteProduct();
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [isDeletingItems, setIsDeletingItems] = useState(false);
  const [editProductClassifyOpen, setEditProductClassifyOpen] = useState(false);

  const [editProductItem, setEditProductItem] = useState({});
  const [parent, setParent] = useState<any>();
  const [hierarchyType, setHierarchyType] = useState<any>(
    window.sessionStorage.getItem('productDBHierarchy'),
  );

  const handleSortProducts = (key: string) => {
    const newSortOrder =
      localProductSortBy === key && localProductSortOrder === 'asc'
        ? 'desc'
        : 'asc';
    setLocalProductSortBy(key);
    setLocalProductSortOrder(newSortOrder);
  };

  const handleAddProductModalClose = () => {
    setParent(null);
    setShowAddProductModal(false);
  };

  const handleAddProductModalOpen = (parent: any) => {
    setParent(parent);
    setShowAddProductModal(true);
  };

  const handleClassifyOpen = (product: any) => {
    setEditProductItem(product);
    setEditProductClassifyOpen(true);
  };

  const handleEdit = async (item: any) => {
    setEditProductItem(item);
    history.push(`/product/${item.id}`, {
      objectData: {
        ...item,
      },
    });
  };

  const handleDeleteProduct = async () => {
    deleteProductMutation.mutateAsync(deleteId).then(() => {
      refetchProducts();
    });
  };

  const paginationParams: PaginationParams = {
    page: currentProductPage,
    limit: localProductLimit,
    sortBy: localProductSortBy,
    sortOrder: localProductSortOrder,
    exclusions: [],
    hierarchy_type: hierarchyType,
    hasIssues: hasIssues,
  };

  const {
    data: productsData,
    pagination: productsPagination,
    isLoading: isProductsLoading,
    refetch: refetchProducts,
  } = useGetProductsByGroupId(
    cur_user?.selected_team?.id ?? '-1',
    localProductSearchTerm,
    paginationParams,
  );

  const { data: stats } = useGetProductDbStatsByGroupId(
    cur_user?.selected_team?.id ?? '-1',
  );

  // Handle products loading errors
  useEffect(() => {
    if (dbsError) {
      enqueueSnackbar('Failed to fetch product databases', {
        variant: 'error',
      });
    }
  }, [dbsError]);

  return (
    <DBModuleHeaderLayout
      title='Product DB'
      handleRefresh={() => {
        if (!isInteractionDisabled) {
          refetchDbs();
        }
      }}
      onDatabaseCreated={handleDatabaseCreated}
      onDatabaseUploadFailed={handleDatabaseUploadFailed}
    >
      <RequiredLicense
        userLicense={normalizedLicense}
        minimumLicense='business'
      />
      <div
        className='team-content-container margined-container'
        style={{ paddingTop: '0px' }}
      >
        <div className='people-col'>
          {!showDatabaseSettingsModal && (
            <>
              <div className='team-content-header'>
                <div className='team-content-search people-col'>
                  <h1 className='bdb-nc-page-title'>Product Databases</h1>
                  <p className='bdb-nc-page-subtitle'>
                    {' '}
                    {
                      'Manage your product inventory and view relationships with suppliers.'
                    }
                  </p>
                </div>
                <div className='module-header-title-conts'>
                  <div
                    className='module-header-btns'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    <div
                      className='module-header-help'
                      onClick={() => {
                        if (!isInteractionDisabled) {
                          setHelpModalOpen(true);
                        }
                      }}
                      role='button'
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (
                          !isInteractionDisabled &&
                          (event.key === 'Enter' || event.key === ' ')
                        ) {
                          setHelpModalOpen(true);
                        }
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                      >
                        <g clipPath='url(#clip0_16034_866)'>
                          <path
                            d='M7.57484 7.50001C7.77076 6.94306 8.15746 6.47343 8.66647 6.17428C9.17547 5.87514 9.77392 5.76579 10.3558 5.8656C10.9377 5.96541 11.4655 6.26794 11.8457 6.71961C12.226 7.17128 12.4341 7.74294 12.4332 8.33334C12.4332 10 9.93317 10.8333 9.93317 10.8333M9.99984 14.1667H10.0082M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z'
                            stroke='#94969C'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_16034_866'>
                            <rect width='20' height='20' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      <p>Help</p>
                    </div>

                    <button
                      className='btn-new-automate bdb-nc-toggle-btn'
                      onClick={() => {
                        setIsDatabaseView(!isDatabaseView);
                      }}
                    >
                      <div>
                        {isDatabaseView
                          ? 'View All Products'
                          : 'View All Databases'}
                      </div>
                    </button>


                    <button
                      className='btn-new-automate'
                      style={{
                        opacity: isInteractionDisabled ? 0.6 : 1,
                        cursor: isInteractionDisabled
                          ? 'not-allowed'
                          : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        verticalAlign: 'middle',
                      }}
                      disabled={isInteractionDisabled}
                      onClick={() =>
                        !isInteractionDisabled &&
                        setShowDatabaseSettingsModal(!showDatabaseSettingsModal)
                      }
                    >
                      {isInteractionDisabled && <LockIcon fontSize='small' />}
                      <div>
                        {showDatabaseSettingsModal
                          ? 'Return To Databases'
                          : 'Settings'}
                      </div>
                    </button>
                    <button
                      className='btn-new-automate'
                      disabled={isInteractionDisabled}
                      style={{
                        opacity: isInteractionDisabled ? 0.6 : 1,
                        cursor: isInteractionDisabled
                          ? 'not-allowed'
                          : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                      }}
                      onClick={() => {
                        if (!isInteractionDisabled) {
                          setShowCreateProductDatabaseModal(true);
                        }
                      }}
                    >
                      {isInteractionDisabled && <LockIcon fontSize='small' />}
                      {!isInteractionDisabled && (
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='white'
                          strokeWidth='2.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        >
                          <path d='M12 5v14M5 12h14' />
                        </svg>
                      )}
                      <div>Create Database</div>
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
          {showDatabaseSettingsModal && (
            <>
              <div className='team-content-header'>
                <div className='team-content-search people-col'>
                  <div className='card-db-header'>
                    <div className='card-db-icon'>
                      <SettingsIcon
                        sx={{
                          fontSize: 20,
                          color: 'var(--Primary-400, var(--action-color))',
                        }}
                      />
                    </div>
                    <div className='card-db-title'>Settings</div>
                  </div>
                  <span className='card-db-meta-span'>
                    {' '}
                    {
                      'Manage your database settings. Settings include Contacts, API Keys, and more.'
                    }
                  </span>
                </div>
                <div className='module-header-title-conts'>
                  <div className='module-header-btns'>
                    <div
                      className='module-header-help'
                      onClick={() => {
                        if (!isInteractionDisabled) {
                          setHelpModalOpen(true);
                        }
                      }}
                      role='button'
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (
                          !isInteractionDisabled &&
                          (event.key === 'Enter' || event.key === ' ')
                        ) {
                          setHelpModalOpen(true);
                        }
                      }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                        fill='none'
                      >
                        <g clipPath='url(#clip0_16034_866)'>
                          <path
                            d='M7.57484 7.50001C7.77076 6.94306 8.15746 6.47343 8.66647 6.17428C9.17547 5.87514 9.77392 5.76579 10.3558 5.8656C10.9377 5.96541 11.4655 6.26794 11.8457 6.71961C12.226 7.17128 12.4341 7.74294 12.4332 8.33334C12.4332 10 9.93317 10.8333 9.93317 10.8333M9.99984 14.1667H10.0082M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z'
                            stroke='#94969C'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_16034_866'>
                            <rect width='20' height='20' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                      <p>Help</p>
                    </div>

                    <button
                      className='btn-new-automate'
                      style={{ verticalAlign: 'middle' }}
                      disabled={isInteractionDisabled}
                      onClick={() =>
                        !isInteractionDisabled &&
                        setShowDatabaseSettingsModal(!showDatabaseSettingsModal)
                      }
                    >
                      {isInteractionDisabled && <LockIcon fontSize='small' />}
                      <div>
                        {showDatabaseSettingsModal
                          ? 'Return To Databases'
                          : 'Settings'}
                      </div>
                    </button>
                    <button
                      className='btn-new-automate'
                      disabled={isInteractionDisabled}
                      onClick={() => {
                        if (!isInteractionDisabled) {
                          setShowCreateProductDatabaseModal(true);
                        }
                      }}
                    >
                      {isInteractionDisabled && <LockIcon fontSize='small' />}
                      <div>Create Database</div>
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {!showDatabaseSettingsModal && (
          <>
            <div
              className='api-container-info'
              style={{
                padding: '0px 0px 0px 0px',
                width: '100%',
                marginTop: '24px',
              }}
            >
              <div
                className='card-grid-six'
                style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}
              >
                <StatCard
                  icon={<DatabaseIcon color='var(--action-color)' size={20} />}
                  label={'Total Databases'}
                  value={`${stats?.total_product_databases ?? '0'}`}
                  variant='default'
                  onClick={() => {
                    setIsDatabaseView(true);
                  }}
                />
                <StatCard
                  icon={
                    <Inventory2OutlinedIcon
                      sx={{ fontSize: 20, color: 'var(--action-color)' }}
                    />
                  }
                  label={'Total Products'}
                  value={`${stats?.total_products ?? '0'}`}
                  variant='default'
                  onClick={() => {
                    setHierarchyType('');

                    window.sessionStorage.setItem('productDBHierarchy', '');
                    setHasIssues(false);
                    setIsDatabaseView(false);
                  }}
                />
                <StatCard
                  icon={
                    <BrightnessHighIcon
                      style={{ fontSize: 20, color: 'var(--full-bar-color)' }}
                    />
                  }
                  label={'Assemblies'}
                  value={`${stats?.total_assemblies_products ?? '0'}`}
                  variant='default'
                  onClick={() => {
                    if (hierarchyType === 'Assembly') {
                      setHierarchyType('');

                      window.sessionStorage.setItem('productDBHierarchy', '');
                    } else {
                      setHierarchyType('Assembly');
                      window.sessionStorage.setItem(
                        'productDBHierarchy',
                        'Assembly',
                      );
                    }
                    setHasIssues(false);
                    setIsDatabaseView(false);
                  }}
                />
                <StatCard
                  icon={
                    <ReportProblemOutlinedIcon
                      sx={{ fontSize: 20, color: 'var(--alert-text-color)' }}
                    />
                  }
                  label={'Issues'}
                  value={`${stats?.total_issues_products ?? '0'}`}
                  variant='default'
                  onClick={() => {
                    setHierarchyType('');
                    window.sessionStorage.setItem('productDBHierarchy', '');
                    setHasIssues(!hasIssues);
                    setIsDatabaseView(false);
                  }}
                />
              </div>
              <div>
                {isDatabaseView ? (
                  <>
                    <div
                      className='widget-search'
                      style={{
                        marginBottom: '10px',
                        marginTop: '30px',
                        marginLeft: '0px',
                        marginRight: '0px',
                        width: '100%',
                      }}
                    >
                      <div
                        className='widget-search-input'
                        style={{ width: '100%' }}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                        >
                          <path
                            d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z'
                            stroke='var(--text-classify)'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                        <input
                          placeholder='Search Databases'
                          id='primary'
                          type='text'
                          className='screening-input-field-content'
                          style={{ width: '100%' }}
                          name='primary'
                          value={localSearchTerm}
                          onChange={(e) => {
                            setLocalSearchTerm(e.target.value);
                          }}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                              // Additional action on Enter if needed
                            }
                          }}
                        />
                      </div>
                      <div
                        className='widget-search-input'
                        style={{ width: 'fit-content' }}
                      >
                        <ChecklistRtlIcon
                          onClick={() =>
                            setOpenRules && setOpenRules(!openRules)
                          }
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                      <div className='bdb-nc-view-toggle'>
                        <button
                          className={`bdb-nc-view-btn${
                            !isTableView ? ' active' : ''
                          }`}
                          onClick={() => setIsTableView(false)}
                          title='Grid view'
                        >
                          <svg
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          >
                            <rect x='3' y='3' width='7' height='7' />
                            <rect x='14' y='3' width='7' height='7' />
                            <rect x='3' y='14' width='7' height='7' />
                            <rect x='14' y='14' width='7' height='7' />
                          </svg>
                        </button>
                        <button
                          className={`bdb-nc-view-btn${
                            isTableView ? ' active' : ''
                          }`}
                          onClick={() => setIsTableView(true)}
                          title='List view'
                        >
                          <svg
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          >
                            <line x1='8' y1='6' x2='21' y2='6' />
                            <line x1='8' y1='12' x2='21' y2='12' />
                            <line x1='8' y1='18' x2='21' y2='18' />
                            <line x1='3' y1='6' x2='3.01' y2='6' />
                            <line x1='3' y1='12' x2='3.01' y2='12' />
                            <line x1='3' y1='18' x2='3.01' y2='18' />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className='bdb-nc-db-grid'>
                      {dbsLoading ? (
                        <CircularProgress color='primary' />
                      ) : databases.length === 0 ? (
                        <div
                          className='detail-item cols-span-four'
                          style={{ textAlign: 'center' }}
                        >
                          No Databases Found
                        </div>
                      ) : (
                        <>
                          {isTableView && (
                            <div className='table-headers cols-span-four'>
                              <MasterTable
                                cols={
                                  <DatabaseColumns
                                    sortData={handleSort}
                                    sortConfig={{
                                      key: sortBy,
                                      direction: sortOrder,
                                    }}
                                  />
                                }
                                suppliersData={databases}
                                selectedItems={[]}
                                setSelectedItems={(items: any[]) => {
                                  return;
                                }}
                                loading={dbsLoading}
                                currentPage={dbsPagination?.currentPage || 1}
                                totalPages={dbsPagination?.totalPages || 1}
                                onPageChange={handlePageChange}
                                customRowComponent={(props: any) => (
                                  <DatabaseRow
                                    transaction={props.transaction}
                                    handleEdit={() => {
                                      history.push(
                                        `/database/${props.transaction.id}`,
                                      );
                                    }}
                                    handleDelete={() => {
                                      setDeleteId(props.transaction.id);
                                      setIsDeleteModalOpen(true);
                                    }}
                                  />
                                )}
                              />
                            </div>
                          )}
                          {!isTableView &&
                            databases.map((database: any, index: number) => {
                              return (
                                <CardDB
                                  key={index}
                                  database={database}
                                  isProcessing={processingDatabases.has(
                                    database.id.toString(),
                                  )}
                                />
                              );
                            })}
                        </>
                      )}
                      {!isTableView && (dbsPagination?.totalPages || 1) > 1 && (
                        <div
                          className='hb-pagination cols-span-four'
                          style={{ width: '100%' }}
                        >
                          <Pagination
                            onChange={handlePageChange}
                            size='large'
                            count={dbsPagination?.totalPages ?? 1}
                            shape='rounded'
                            variant='text'
                            page={dbsPagination?.currentPage ?? 1}
                          />
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className='widget-search'
                      style={{
                        marginBottom: '10px',
                        marginTop: '30px',
                        marginLeft: '0px',
                        marginRight: '0px',
                        width: '100%',
                      }}
                    >
                      <div
                        className='widget-search-input'
                        style={{ width: '100%' }}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                        >
                          <path
                            d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z'
                            stroke='var(--text-classify)'
                            strokeWidth='1.66667'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                        <input
                          placeholder='Search Products'
                          id='primary'
                          type='text'
                          className='screening-input-field-content'
                          style={{ width: '100%' }}
                          name='primary'
                          value={localProductSearchTerm}
                          onChange={(e) => {
                            setLocalProductSearchTerm(e.target.value);
                          }}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                              // Additional action on Enter if needed
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className='widget-content'
                      style={{
                        width: '100%',
                      }}
                    >
                      <MasterTable
                        cols={
                          <ProductColumns
                            sortData={handleSortProducts}
                            sortConfig={{ key: sortBy, direction: sortOrder }}
                          />
                        }
                        loading={isProductsLoading}
                        suppliersData={productsData}
                        location={'/product'}
                        selectedItems={[]}
                        setSelectedItems={(items: any[]) => {
                          return;
                        }}
                        currentPage={productsPagination?.currentPage || 1}
                        totalPages={productsPagination?.totalPages || 1}
                        onPageChange={handlePageChangeProduct}
                        customRowComponent={(props: any) => (
                          <ProductRow
                            key={props.transaction.id}
                            location={`/product/${props.transaction.id}`}
                            viewType='Product View'
                            transaction={props.transaction}
                            handleEdit={handleEdit}
                            handleDelete={(entity: any) => {
                              setDeleteId(entity.id);
                              setIsDeletingItems(true);
                            }}
                            handleClassify={handleClassifyOpen}
                            handleAdd={handleAddProductModalOpen}
                            aiInProgress={props.aiInProgress}
                          />
                        )}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        )}
        {showDatabaseSettingsModal && (
          <div className='widget-container'>
            <div className='screening-tabs-container'>
              <div className='screening-tabs-inner' style={{ width: '100%' }}>
                <div
                  className={`screening-tab-btn${
                    settingTab === 'Contacts' ? '-selected' : ''
                  }`}
                  onClick={() => handleSettingTabChange('Contacts')}
                >
                  <div
                    className={`screening-tab-btn-text${
                      settingTab === 'Contacts' ? '-selected' : ''
                    }`}
                  >
                    {settingTab === 'Contacts' ? (
                      <ContactsIcon
                        sx={{
                          fontSize: 18,
                          color: 'var(--action-color)',
                          mr: '5px',
                        }}
                      />
                    ) : (
                      <ContactsIcon
                        sx={{
                          fontSize: 18,
                          color: 'var(--text-classify)',
                          mr: '5px',
                        }}
                      />
                    )}
                    Contacts
                  </div>
                </div>
                <div
                  className={`screening-tab-btn${
                    settingTab === 'Data Sources' ? '-selected' : ''
                  }`}
                  onClick={() => handleSettingTabChange('Data Sources')}
                >
                  <div
                    className={`screening-tab-btn-text${
                      settingTab === 'Data Sources' ? '-selected' : ''
                    }`}
                  >
                    {settingTab === 'Data Sources' ? (
                      <DatabaseIcon color='var(--action-color)' size={20} />
                    ) : (
                      <DatabaseIcon color='var(--text-classify)' size={20} />
                    )}
                    Data Sources (Coming Soon)
                  </div>
                </div>
                <div
                  className={`screening-tab-btn${
                    settingTab === 'Uploads' ? '-selected' : ''
                  }`}
                  onClick={() => handleSettingTabChange('Uploads')}
                >
                  <div
                    className={`screening-tab-btn-text${
                      settingTab === 'Uploads' ? '-selected' : ''
                    }`}
                  >
                    {settingTab === 'Uploads' ? (
                      <DatabaseIcon color='var(--action-color)' size={20} />
                    ) : (
                      <DatabaseIcon color='var(--text-classify)' size={20} />
                    )}
                    Uploads
                  </div>
                </div>
              </div>
            </div>
            {settingTab === 'Contacts' && <ContactsTable />}
            {settingTab === 'Data Sources' && (
              <div className='api-container'>
                <div className='dashboard-cards-no-database'>
                  <svg
                    width='215'
                    height='188'
                    viewBox='0 0 215 188'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M214.843 77.765V13.6589C214.843 6.69228 209.204 1.04533 202.247 1.04533H135.392C128.436 1.04533 122.795 6.69228 122.795 13.6589V77.765H214.843Z'
                      fill='#4488E1'
                    />
                    <path
                      d='M172.243 16.0765L165.776 22.5433M165.776 16.0765L172.243 22.5433M179.788 19.3099C179.788 25.2624 174.962 30.0879 169.01 30.0879C163.057 30.0879 158.232 25.2624 158.232 19.3099C158.232 13.3574 163.057 8.53188 169.01 8.53188C174.962 8.53188 179.788 13.3574 179.788 19.3099Z'
                      stroke='white'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M198.128 38.2294H139.509C134.515 38.2294 130.466 42.2839 130.466 47.2854V116.908C130.466 121.91 134.515 125.964 139.509 125.964H198.128C203.122 125.964 207.171 121.91 207.171 116.908V47.2854C207.171 42.2839 203.122 38.2294 198.128 38.2294Z'
                      fill='white'
                    />
                    <path
                      d='M193.331 49.8221H144.309V50.1622H193.331V49.8221Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M193.331 114.026H144.309V114.366H193.331V114.026Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M193.331 104.854H144.309V105.194H193.331V104.854Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M193.331 95.6822H144.309V96.0223H193.331V95.6822Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M193.331 86.5079H144.309V86.848H193.331V86.5079Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M193.331 77.3382H144.309V77.6783H193.331V77.3382Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M193.331 68.1661H144.309V68.5063H193.331V68.1661Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M193.331 58.9941H144.309V59.3342H193.331V58.9941Z'
                      fill='#D6D6D6'
                    />
                    <path
                      d='M110.69 127.567C114.57 134.726 116.707 142.964 117.392 151.083C115.145 151.203 112.981 151.053 110.752 150.752C110.663 142.916 109.071 135.105 106.069 127.867C107.752 127.976 109.008 127.633 110.686 127.574L110.69 127.567Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M113.794 118.595C114.648 119.961 115.243 121.547 115.595 123.25C116.005 125.263 115.877 127.459 114.834 129.23C113.906 130.82 112.296 131.954 110.534 132.478C104.829 134.176 99.2645 130.059 97.6715 124.651C97.1616 122.919 96.9391 121.045 97.4454 119.314C98.6104 115.303 102.524 113.382 106.507 113.885C109.81 114.302 112.234 116.082 113.801 118.599L113.794 118.595Z'
                      fill='#23377D'
                    />
                    <path
                      d='M102.626 119.646C103.327 122.773 104.194 125.862 105.163 128.917C103.99 128.671 102.886 127.931 102.151 126.962C100.581 124.895 100.5 121.264 102.626 119.646Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M105.09 118.85C108.049 118.956 109.254 123.061 109.53 125.573C109.568 125.934 109.606 126.295 109.517 126.644C109.393 127.127 109.038 127.528 108.663 127.856C108.378 128.102 108.069 128.334 107.742 128.526C106.726 125.34 105.823 122.118 105.098 118.854L105.09 118.85Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M108.911 168.013L123.263 167.281C123.34 163.803 123.142 160.32 122.263 156.967C122.224 156.822 122.188 156.688 122.149 156.542C122.058 156.202 121.916 155.699 121.721 155.094C120.8 152.117 118.783 146.732 115.542 146.812C114.712 146.826 113.904 147.14 113.224 147.517C108.875 149.926 109.194 154.373 109.054 157.568C108.995 158.756 108.98 160.011 108.983 161.286C108.975 162.011 108.979 162.752 108.983 163.474C108.978 165.032 108.976 166.582 108.926 168.021L108.911 168.013Z'
                      fill='white'
                    />
                    <path
                      d='M127.128 164.7C126.357 163.597 125.406 162.576 124.17 162.047C123.059 161.57 121.798 161.53 120.597 161.617C117.115 161.866 113.714 163.148 110.93 165.248C109.699 166.17 108.503 167.442 108.518 168.981C108.519 168.889 120.631 168.96 121.75 168.979C125.7 169.041 130.773 169.916 127.132 164.712L127.128 164.7Z'
                      fill='#23377D'
                    />
                    <path
                      d='M108.968 163.466C110.982 162.184 112.168 159.613 113.829 157.84C115.14 156.44 117.273 155.237 119.256 155.396C120.629 155.511 121.488 156.14 122.263 156.968C122.224 156.822 122.188 156.689 122.149 156.543C122.058 156.203 121.917 155.7 121.722 155.094C120.047 154.117 117.704 153.833 116.225 154.242C114.304 154.776 112.733 156.18 111.563 157.744C110.723 158.861 109.987 160.295 108.968 161.278C108.96 162.003 108.964 162.744 108.968 163.466Z'
                      fill='#3E76CD'
                    />
                    <g filter='url(#filter0_d_15_166)'>
                      <path
                        d='M70.3139 132.838C69.9697 132.838 69.6842 133.106 69.4659 133.366C67.5936 135.532 66.5692 138.294 65.822 141.055C64.7557 145.034 64.2016 149.936 66.0403 153.621C68.3912 153.328 70.7001 153.219 72.9839 152.572C72.5137 149.592 72.0687 146.596 72.0855 143.574C72.0939 140.56 72.5809 137.496 73.8906 134.777C73.9914 134.659 74.2265 134.709 74.2601 134.861C72.8075 134.407 71.6405 133.576 70.3139 132.838Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M81.5063 124.486C81.8506 126.139 81.859 127.919 81.5819 129.732C81.2545 131.864 80.3225 133.98 78.6517 135.348C77.1572 136.573 75.1589 137.111 73.2278 136.985C66.9811 136.582 63.0014 130.496 63.4044 124.578C63.5303 122.689 63.9921 120.759 65.1256 119.239C67.7368 115.714 72.2958 115.244 76.0405 117.191C79.1386 118.803 80.885 121.439 81.5147 124.494L81.5063 124.486Z'
                        fill='#23377D'
                      />
                      <path
                        d='M70.1038 121.45C69.6588 124.791 69.3818 128.149 69.2306 131.515C68.1643 130.851 67.3415 129.718 66.9721 128.493C66.1745 125.891 67.4171 122.273 70.1122 121.45H70.1038Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M72.8318 121.567C75.7117 122.751 75.4011 127.233 74.7546 129.81C74.6622 130.18 74.5614 130.549 74.3431 130.859C74.0409 131.296 73.5455 131.548 73.0585 131.741C72.6891 131.884 72.3029 132.001 71.9083 132.06C72.0678 128.551 72.3533 125.042 72.8318 121.567Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M63.6802 168.017L77.0635 167.497C77.1727 164.257 77.03 161.008 76.2491 157.877C76.2155 157.743 76.182 157.609 76.1484 157.483C76.0644 157.164 75.9385 156.694 75.7705 156.131C74.9477 153.345 73.1258 148.308 70.1032 148.342C69.3307 148.342 68.5751 148.627 67.937 148.971C63.8565 151.17 64.1084 155.309 63.9321 158.289C63.8649 159.397 63.8397 160.563 63.8145 161.755C63.7977 162.435 63.7893 163.115 63.7893 163.795C63.7642 165.247 63.7474 166.691 63.6802 168.034V168.017Z'
                        fill='white'
                      />
                      <path
                        d='M80.7072 165.138C80.0019 164.106 79.1203 163.14 77.9785 162.628C76.9458 162.167 75.7787 162.116 74.6536 162.183C71.4044 162.385 68.2222 163.535 65.6027 165.457C64.444 166.305 63.3189 167.472 63.3105 168.907C63.3105 168.823 74.6033 169.025 75.6444 169.058C79.3303 169.159 84.0404 170.04 80.7072 165.138Z'
                        fill='#23377D'
                      />
                      <path
                        d='M63.7886 163.778C65.6862 162.603 66.8112 160.227 68.3813 158.59C69.6155 157.298 71.6222 156.206 73.4609 156.374C74.7371 156.492 75.5264 157.096 76.2484 157.868C76.2148 157.734 76.1812 157.6 76.1477 157.474C76.0637 157.155 75.9378 156.685 75.7698 156.122C74.225 155.191 72.042 154.897 70.6566 155.266C68.8683 155.745 67.3822 157.037 66.2739 158.473C65.4846 159.505 64.7794 160.832 63.8138 161.738C63.797 162.418 63.7886 163.098 63.7886 163.778Z'
                        fill='#3E76CD'
                      />
                      <path
                        d='M28.3034 128.012C30.8676 128.142 33.9746 128.578 35.4682 130.811C37.8353 130.724 40.2003 131.603 41.2435 133.939C41.8107 135.212 39.9353 136.323 39.3578 135.044C38.7994 133.803 37.7429 133.104 36.3944 132.97C36.3311 132.961 36.2619 132.962 36.2008 132.961C36.2514 135.129 34.0937 136.776 31.8109 135.815C30.7628 135.374 30.3336 134.194 30.7007 133.131C31.0447 132.144 31.9337 131.602 32.8814 131.278C32.7845 131.209 32.6795 131.141 32.5848 131.08C31.3151 130.299 29.7343 130.27 28.2869 130.189C26.8947 130.119 26.8928 127.938 28.3012 128.004L28.3034 128.012ZM32.6344 133.308C32.2977 133.512 32.0391 133.876 32.1693 134.233C32.3445 134.724 33.0757 134.728 33.5108 134.438C33.7907 134.25 34.413 133.588 34.2881 133.187C34.1204 132.658 33.3485 133.021 32.8728 133.192C32.7917 133.214 32.7171 133.26 32.6344 133.308Z'
                        fill='#23377D'
                      />
                      <path
                        d='M28.6336 131.642C20.3314 127.94 12.1134 124.033 4.00001 119.933C4.41896 119.29 4.83792 118.648 5.25687 118.006C13.2989 119.796 21.335 122.57 29.1039 125.32C29.8277 126.821 30.5514 128.322 31.2751 129.822C30.3431 130.593 29.4562 131.144 28.6336 131.642Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M13.5937 120.186C15.0079 120.597 16.4206 121.036 17.8191 121.487C16.7637 122.673 15.9503 124.082 15.4539 125.57C14.068 124.908 12.6779 124.229 11.298 123.555C11.9034 122.376 12.7399 121.249 13.5937 120.186Z'
                        fill='#4CC9F0'
                      />
                      <path
                        d='M50.4013 160.178C52.3788 160.508 58.0639 156.964 61.4443 155.291C73.967 149.105 102.862 134.425 109.059 127.673C117.025 119.005 106.025 90.652 106.025 90.652L82.5041 81.0841L72.7227 78.8722C70.0558 92.6175 38.3148 130.806 38.3024 133.235C18.4311 157.871 40.184 157.541 44.1391 158.201C44.1391 158.201 45.4574 158.86 46.1166 158.86L50.4013 160.178Z'
                        fill='white'
                      />
                      <path
                        d='M51.7171 152.99C53.9858 156.001 58.0736 156.968 61.4541 155.296C73.9768 149.109 102.871 134.43 109.069 127.678C112.949 123.452 112.331 114.556 110.673 106.54C110.541 105.872 110.39 105.209 110.238 104.554C108.487 96.9646 106.037 90.6486 106.037 90.6486C101.807 89.3618 97.5772 88.075 93.3475 86.7882C90.1422 85.8166 86.9386 84.8366 83.7334 83.865C81.9414 83.3201 79.1467 81.2747 77.272 82.0485C77.9536 83.6135 79.6231 85.1183 80.6816 86.51C84.3188 91.2907 88.5861 97.2067 88.268 103.537C88.0032 108.782 85.7507 113.691 83.9542 118.546C83.0001 121.104 81.5402 123.449 79.9584 125.676C72.3241 136.422 61.4666 144.823 49.1961 149.613C49.4731 149.985 49.7435 150.347 50.0139 150.708C50.5893 151.473 51.1367 152.207 51.6577 152.901C51.6775 152.931 51.7055 152.962 51.7253 152.992L51.7171 152.99Z'
                        fill='#EDEDED'
                      />
                      <path
                        d='M51.6407 152.9C54.4259 152.11 57.1367 151.007 59.6319 149.954C70.4455 145.387 81.6829 139.852 89.7474 131.118C95.922 124.439 101.433 114.212 97.8357 105.057C100.478 104.085 103.08 102.926 105.484 101.47C106.656 103.021 107.967 104.437 109.484 105.672C109.867 105.988 110.262 106.281 110.648 106.537C110.515 105.869 110.365 105.206 110.213 104.551C108.761 103.158 107.49 101.587 106.497 99.9511C106.257 99.5612 105.806 99.2916 105.35 99.5176C102.291 101.04 99.2689 102.458 96.0147 103.497C95.4846 103.665 95.268 104.41 95.4842 104.872C97.7317 109.667 96.8924 115.089 94.8026 119.783C90.347 129.783 80.4908 136.594 71.1431 141.581C66.4314 144.092 61.5829 146.431 56.6617 148.49C54.4496 149.411 52.229 150.115 49.9804 150.704C50.5558 151.469 51.1032 152.202 51.6242 152.897L51.6407 152.9Z'
                        fill='#3E76CD'
                      />
                      <path
                        d='M101.401 77.9087L106.029 90.6579C106.029 90.6579 85.8077 93.1128 72.7261 78.8781L83.6167 67.4285L101.402 77.9005L101.401 77.9087Z'
                        fill='#4488E1'
                      />
                      <path
                        d='M104.186 26.8528C104.086 31.1926 100.677 36.2291 96.252 37.1104C91.08 38.1345 85.5218 32.7287 84.2036 28.1035C82.5328 22.2276 86.4958 14.6142 93.1706 14.9835C98.9219 15.3025 104.312 21.1112 104.178 26.8528H104.186Z'
                        fill='#23377D'
                      />
                      <path
                        d='M89.1151 20.3222C82.4066 14.1861 75.8409 7.88209 69.4431 1.427C70.0392 0.948535 70.6437 0.470072 71.2399 0C78.3094 4.23904 85.0514 9.40982 91.5584 14.4715C91.7683 16.1251 91.9866 17.7788 92.1965 19.4324C91.0714 19.8689 90.0555 20.1124 89.1151 20.3306V20.3222Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M78.4695 4.69393C79.6786 5.53335 80.8792 6.38955 82.0714 7.26254C80.6945 8.05998 79.4771 9.13442 78.5367 10.3935C77.4284 9.32749 76.3285 8.24465 75.2286 7.1702C76.1774 6.23845 77.3277 5.44101 78.4695 4.70232V4.69393Z'
                        fill='#4CC9F0'
                      />
                      <path
                        d='M89.7875 22.1053C89.7287 22.0382 89.6699 21.9794 89.6027 21.9207C90.1905 21.7192 90.8118 21.5933 91.4415 21.5681C94.8839 21.3918 97.2599 23.8177 98.3766 26.8984C99.0315 28.7199 98.9812 30.9024 98.0576 32.4721C95.0602 29.2236 92.6337 25.4798 89.7875 22.1053Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M86.2521 25.2772C86.3613 24.8911 86.5124 24.5301 86.6971 24.2027C86.907 23.8334 87.1757 23.506 87.478 23.2122C87.5115 23.4389 87.6039 23.6655 87.7886 23.8838C90.6349 27.2498 93.0446 30.9852 96.0336 34.2253C95.5718 34.4016 95.0512 34.5191 94.4635 34.5359C93.4056 34.5695 92.3729 34.2505 91.4157 33.7972C88.4939 32.3954 85.2782 28.7775 86.2437 25.2772H86.2521Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M98.9058 24.5035C99.2164 25.1666 99.8042 25.813 100.358 26.2914C102.071 25.7626 104.019 25.1834 105.732 24.6546C105.623 23.0177 104.959 21.4228 103.868 20.1973C102.298 21.3473 100.425 23.2863 98.9058 24.5119V24.5035Z'
                        fill='#4CC9F0'
                      />
                      <path
                        d='M97.8821 20.4662C98.2851 20.8272 98.8645 21.0958 99.3766 21.2553C100.384 20.4075 101.534 19.4673 102.542 18.6195C102.005 17.5451 101.098 16.6553 100.006 16.1349C99.2759 17.3604 98.5538 19.2071 97.8821 20.4662Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M70.5287 31.2283C60.5793 44.0881 60.5289 60.4818 71.9728 72.3343C87.7658 88.6861 119.906 94.6628 133.692 76.4978C135.707 73.8453 137.244 70.4876 137.227 67.2475C137.227 65.9296 136.975 64.6369 136.396 63.4198C134.725 59.8858 130.922 58.0056 127.605 55.949C124.767 54.1862 122.039 52.0373 120.418 49.1078C119.394 47.2611 118.856 45.1961 118.118 43.2235C114.826 34.5355 108.395 25.3692 100.184 20.7356C93.6179 17.0254 86.6911 18.3768 80.7131 21.9779C76.7837 24.3535 73.2574 27.7027 70.5287 31.2283Z'
                        fill='white'
                      />
                      <path
                        d='M70.5287 31.2287C60.5793 44.0885 60.5289 60.4823 71.9728 72.3348C87.7658 88.6866 119.906 94.6632 133.692 76.4983C135.707 73.8458 137.244 70.4881 137.227 67.2479C135.959 69.3465 134.893 71.1177 134.263 71.7808C130.183 76.0534 124.583 78.9158 118.739 79.7468C108.58 81.1906 98.2021 77.2202 90.0831 70.9414C81.3008 64.1421 74.4748 53.9684 74.2985 42.8714C74.1809 35.4761 76.9433 28.4419 80.7131 21.9868C76.7837 24.3623 73.2574 27.7116 70.5287 31.2371V31.2287Z'
                        fill='#EDEDED'
                      />
                      <path
                        d='M131.995 75.6343C128.091 74.8033 127.159 63.8909 129.183 61.1796C129.93 60.1891 131.382 60.1051 132.608 60.3066C137.151 61.0453 141.055 63.9497 139.266 68.8015C138.368 71.2442 136.563 73.4686 134.43 74.9544C133.515 75.5923 132.701 75.777 131.987 75.6259L131.995 75.6343Z'
                        fill='#23377D'
                      />
                      <path
                        d='M79.2665 41.3924C78.5529 45.6734 74.4556 50.1726 69.9553 50.4077C64.6909 50.6847 59.9639 44.5402 59.3174 39.7807C58.503 33.7285 63.5071 26.753 70.0644 28.0709C75.7066 29.2041 80.2153 35.7179 79.2665 41.3924Z'
                        fill='#23377D'
                      />
                      <path
                        d='M65.2799 32.782C59.5118 25.7477 53.92 18.5791 48.4962 11.2762C49.1594 10.8901 49.8143 10.504 50.4776 10.1178C56.867 15.3222 62.8114 21.3996 68.5292 27.3342L68.4536 32.3287C67.2782 32.5973 66.2371 32.6981 65.2799 32.7736V32.782Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M56.9666 15.7901C58.0413 16.7974 59.1076 17.8131 60.1655 18.8455C58.6878 19.4331 57.3276 20.3313 56.2194 21.4393C55.2706 20.2222 54.3386 18.9966 53.4067 17.7795C54.4814 16.9904 55.7324 16.3609 56.9666 15.7985V15.7901Z'
                        fill='#4CC9F0'
                      />
                      <path
                        d='M65.6898 34.6459C65.6395 34.5704 65.5891 34.5032 65.5303 34.4361C66.1432 34.3186 66.7729 34.285 67.4027 34.3438C70.8366 34.6627 72.8433 37.3992 73.5066 40.6058C73.9012 42.5029 73.5318 44.6602 72.3983 46.0788C69.8963 42.4357 68.0324 38.3897 65.6898 34.6376V34.6459Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M61.7345 37.2713C61.894 36.9019 62.0955 36.5745 62.3306 36.2724C62.5909 35.9366 62.9016 35.6512 63.2374 35.3994C63.2374 35.626 63.3046 35.8694 63.4473 36.1045C65.7814 39.8399 67.6453 43.8774 70.139 47.5121C69.6604 47.6212 69.123 47.6632 68.5437 47.596C67.4942 47.4869 66.5119 47.0169 65.6303 46.4293C62.9351 44.6245 60.2736 40.5869 61.7261 37.2629L61.7345 37.2713Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M74.3718 38.3129C74.5901 39.0096 75.0686 39.7399 75.5556 40.2855C77.3272 40.0001 79.3339 39.7063 81.1054 39.4293C81.2314 37.7925 80.8032 36.122 79.8964 34.7454C78.1836 35.6604 76.0426 37.314 74.3718 38.3129Z'
                        fill='#4CC9F0'
                      />
                      <path
                        d='M73.9264 34.175C74.2706 34.5863 74.808 34.9388 75.2865 35.1739C76.4032 34.4771 77.6794 33.7049 78.7961 33.0166C78.4183 31.875 77.6459 30.8677 76.6467 30.1961C75.7483 31.3042 74.7744 33.0334 73.9264 34.1834V34.175Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M82.4 41.7815C81.9466 47.2041 84.9104 52.8953 89.8557 55.1617C93.6171 56.8825 97.9747 56.5887 102.055 55.9172C106.136 55.2373 110.241 54.2132 114.364 54.6077C116.53 54.8092 121.156 56.6727 123.155 55.338C125.178 53.9782 124.951 50.4862 124.431 48.0603C124.338 47.6406 124.246 47.2461 124.145 46.9103C123.129 43.3092 121.618 39.834 119.511 36.7366C116.522 32.3549 112.298 28.6698 107.093 27.2848C106.53 27.1337 105.968 27.0078 105.388 26.8987C100.603 25.9921 95.5063 26.5377 91.2327 28.8461C86.4469 31.4399 82.8618 36.3589 82.4 41.7731V41.7815Z'
                        fill='#3865BB'
                      />
                      <path
                        d='M82.4 41.7815C81.9466 47.2041 84.9104 52.8953 89.8557 55.1617C93.6171 56.8825 97.9747 56.5887 102.055 55.9172C106.136 55.2373 110.241 54.2132 114.364 54.6077C116.53 54.8092 121.156 56.6727 123.155 55.338C125.178 53.9782 124.951 50.4862 124.431 48.0603C120.082 46.7088 113.415 47.5902 110.25 48.2953C104.624 49.5461 98.5708 50.9899 93.2729 48.7234C90.6785 47.6154 88.3612 45.4665 87.7903 42.6965C87.127 39.4479 88.9657 36.191 91.2579 33.7987C94.8094 30.1052 99.6371 27.6626 104.717 26.9826C104.935 26.9491 105.162 26.9239 105.388 26.8987C100.603 25.9921 95.5063 26.5377 91.2327 28.8461C86.4469 31.4399 82.8618 36.3589 82.4 41.7731V41.7815Z'
                        fill='#4488E1'
                      />
                      <path
                        d='M102.207 43.6705C102.274 44.5015 101.729 45.3073 100.99 45.7103C100.251 46.1132 99.3694 46.1551 98.5466 46.0208C97.3711 45.8362 96.2041 45.257 95.566 44.2497C94.9279 43.2424 94.953 41.7818 95.8262 40.9676C96.1537 40.657 96.5819 40.4555 97.0185 40.338C99.2938 39.6833 101.997 41.1354 102.216 43.6705H102.207Z'
                        fill='#4CC9F0'
                      />
                      <path
                        d='M118.31 40.5457C118.923 40.8898 119.469 41.4187 119.738 41.8804C120.242 42.7533 120.393 44.0209 119.603 44.6588C118.839 45.2716 117.672 44.9106 116.933 44.2643C116.102 43.534 115.523 42.3084 115.892 41.192C116.312 39.9329 117.378 40.0168 118.31 40.5457Z'
                        fill='#4CC9F0'
                      />
                    </g>
                    <path
                      d='M96.0297 125.98C98.172 135.988 97.8297 146.687 95.7701 156.714C93.0232 156.062 90.4574 155.115 87.8804 153.956C90.5567 144.481 91.3946 134.489 90.3515 124.694C92.3444 125.424 93.9762 125.462 96.0297 125.98Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M102.952 116.267C103.493 118.213 103.653 120.338 103.474 122.516C103.26 125.093 102.32 127.683 100.436 129.45C98.7509 131.035 96.407 131.838 94.0909 131.847C86.6084 131.871 81.3565 124.936 81.3586 117.851C81.363 115.583 81.7538 113.252 82.9726 111.336C85.8001 106.919 91.201 105.981 95.8189 108C99.6527 109.669 101.944 112.676 102.94 116.271L102.952 116.267Z'
                      fill='#23377D'
                    />
                    <path
                      d='M89.1089 113.573C88.852 117.595 88.7936 121.628 88.8831 125.654C87.5543 124.949 86.4874 123.665 85.9397 122.23C84.7789 119.187 85.96 114.775 89.1089 113.573Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M92.3704 113.496C95.9029 114.673 95.8961 120.04 95.3418 123.171C95.2593 123.616 95.1724 124.07 94.9379 124.458C94.6144 125 94.0435 125.349 93.4697 125.613C93.0352 125.814 92.5864 125.986 92.1258 126.09C92.0272 121.884 92.0874 117.687 92.3704 113.496Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M85.255 174.296L103.311 173.803C103.516 169.428 103.371 165.052 102.372 160.807C102.327 160.629 102.283 160.451 102.241 160.265C102.125 159.838 101.965 159.197 101.756 158.432C100.695 154.657 98.3122 147.84 94.2337 147.834C93.1935 147.831 92.1668 148.192 91.298 148.65C85.7594 151.549 86.0304 157.137 85.7474 161.15C85.6425 162.641 85.5794 164.217 85.5374 165.817C85.5135 166.732 85.4872 167.655 85.4632 168.569C85.4066 170.534 85.3568 172.473 85.2487 174.285L85.255 174.296Z'
                      fill='white'
                    />
                    <path
                      d='M108.256 170.682C107.326 169.273 106.148 167.963 104.615 167.257C103.229 166.619 101.657 166.539 100.137 166.61C95.7589 166.827 91.4437 168.323 87.8769 170.876C86.3042 172.001 84.7632 173.559 84.7329 175.494C84.7371 175.375 99.9585 175.835 101.362 175.889C106.329 176.087 112.67 177.344 108.256 170.682Z'
                      fill='#23377D'
                    />
                    <path
                      d='M85.4703 168.58C88.0406 167.031 89.6047 163.841 91.7453 161.661C93.4315 159.94 96.1575 158.497 98.6306 158.755C100.352 158.93 101.402 159.755 102.37 160.816C102.326 160.638 102.281 160.46 102.239 160.274C102.123 159.847 101.964 159.206 101.754 158.44C99.6846 157.158 96.7504 156.731 94.8736 157.205C92.4528 157.817 90.4256 159.54 88.9151 161.464C87.8281 162.84 86.8616 164.625 85.5445 165.828C85.5205 166.743 85.4943 167.666 85.4703 168.58Z'
                      fill='#3E76CD'
                    />
                    <path
                      d='M50.7329 128.545C51.7217 127.886 52.8348 127.352 53.04 127.227C53.6442 126.86 53.8869 126.679 55.21 126.074C57.5212 125.56 61.3202 125.218 63.951 126.679C72.6172 134.453 67.8286 151.62 70.3819 154.075L59.372 154.074C57.3099 150.967 62.7591 137.842 59.3724 136.291C58.448 135.873 57.5063 135.444 56.4909 135.424C55.0193 135.393 53.6804 136.213 52.516 137.11C50.6898 138.514 49.0633 140.171 47.6852 142.019C47.7202 141.958 45.2645 140.413 45.1461 139.999C44.8136 138.895 43.9247 138.076 44.4707 137.11C45.4595 132.5 49.4146 129.424 50.7329 128.545Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M33.9285 146.305C34.5494 144.39 35.5741 142.535 36.9169 140.829C38.5115 138.807 40.7058 137.165 43.2445 136.727C45.5164 136.331 47.9067 136.949 49.8329 138.211C56.069 142.285 56.6303 150.929 52.7523 156.826C51.5104 158.718 49.9072 160.435 47.8413 161.354C43.0697 163.481 38.064 161.295 35.3285 157.096C33.0611 153.605 32.7935 149.85 33.9322 146.318L33.9285 146.305Z'
                      fill='#23377D'
                    />
                    <path
                      d='M43.9621 156.136C46.3839 152.941 48.6388 149.616 50.7639 146.215C51.4822 147.53 51.6697 149.184 51.3347 150.664C50.639 153.829 47.2335 156.848 43.9535 156.131L43.9621 156.136Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M41.2041 154.418C38.9106 151.513 41.8611 147.043 44.0409 144.747C44.3473 144.416 44.6711 144.095 45.0861 143.896C45.6489 143.621 46.3146 143.647 46.9317 143.738C47.4025 143.802 47.8657 143.92 48.3176 144.077C46.0989 147.62 43.7504 151.088 41.2177 154.415L41.2041 154.418Z'
                      fill='#3865BB'
                    />
                    <path
                      d='M55.8056 171.274L71.7365 171.894C72.1663 168.055 72.2962 164.187 71.6666 160.388C71.6366 160.228 71.6166 160.068 71.5866 159.908C71.5166 159.528 71.4067 158.948 71.2668 158.269C70.5572 154.89 68.8482 148.732 65.2602 148.492C64.3407 148.432 63.4212 148.692 62.6217 149.042C57.5746 151.271 57.4846 156.209 57.0049 159.728C56.825 161.038 56.6851 162.417 56.5451 163.827C56.4652 164.636 56.3952 165.436 56.3253 166.246C56.1654 167.975 56.0055 169.685 55.8056 171.264L55.8056 171.274Z'
                      fill='white'
                    />
                    <path
                      d='M76.2637 169.433C75.5241 168.144 74.5746 166.914 73.2554 166.204C72.0761 165.565 70.6968 165.395 69.3476 165.375C65.4798 165.305 61.592 166.384 58.3039 168.424C56.8547 169.323 55.4055 170.603 55.2656 172.302C55.2656 172.202 68.648 173.492 69.8873 173.622C74.2448 174.082 79.7617 175.561 76.2637 169.433Z'
                      fill='#23377D'
                    />
                    <path
                      d='M56.3247 166.254C58.6833 165.034 60.2424 162.315 62.2513 160.516C63.8404 159.096 66.319 157.977 68.4877 158.356C69.9869 158.616 70.8764 159.406 71.6559 160.396C71.626 160.236 71.606 160.076 71.576 159.916C71.506 159.536 71.3961 158.956 71.2562 158.277C69.5072 157.027 66.9486 156.477 65.2696 156.787C63.1008 157.187 61.2219 158.586 59.7727 160.186C58.7333 161.336 57.7838 162.855 56.5545 163.835C56.4746 164.644 56.4046 165.444 56.3347 166.254L56.3247 166.254Z'
                      fill='#3E76CD'
                    />
                    <defs>
                      <filter
                        id='filter0_d_15_166'
                        x='0'
                        y='0'
                        width='143.71'
                        height='177.183'
                        filterUnits='userSpaceOnUse'
                        colorInterpolationFilters='sRGB'
                      >
                        <feFlood floodOpacity='0' result='BackgroundImageFix' />
                        <feColorMatrix
                          in='SourceAlpha'
                          type='matrix'
                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                          result='hardAlpha'
                        />
                        <feOffset dy='4' />
                        <feGaussianBlur stdDeviation='2' />
                        <feComposite in2='hardAlpha' operator='out' />
                        <feColorMatrix
                          type='matrix'
                          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
                        />
                        <feBlend
                          mode='normal'
                          in2='BackgroundImageFix'
                          result='effect1_dropShadow_15_166'
                        />
                        <feBlend
                          mode='normal'
                          in='SourceGraphic'
                          in2='effect1_dropShadow_15_166'
                          result='shape'
                        />
                      </filter>
                    </defs>
                  </svg>
                  <p>
                    <div className='card-db-title'>Coming soon!</div>
                    <span className='card-db-meta-span'>
                      We are currently working to allow API and data source
                      connections.
                    </span>
                  </p>
                </div>
              </div>
            )}
            {settingTab === 'Uploads' && <UploadsTable />}
          </div>
        )}

        <HelpContentModal
          isOpen={helpModalOpen}
          setIsOpen={setHelpModalOpen}
          title={helpContent?.title || 'Help'}
          description={helpContent?.description}
          helpItems={helpContent?.helpItems || []}
        />

        <Modal
          open={showCreateProductDatabaseModal}
          onClose={() => setShowCreateProductDatabaseModal(false)}
        >
          <CreateProductDatabaseModal
            open={showCreateProductDatabaseModal}
            handleClose={() => setShowCreateProductDatabaseModal(false)}
            handleRefresh={() => refetchDbs()}
            onDatabaseCreated={handleDatabaseCreated}
            onDatabaseUploadFailed={handleDatabaseUploadFailed}
          />
        </Modal>

        <Modal open={openRules} onClose={handleCloseRules}>
          <ComplianceScoringGuidelines setIsOpen={setOpenRules} />
        </Modal>
        <Modal
          open={isDeleteModalOpen}
          onClose={() => {
            setIsDeleteModalOpen(false);
          }}
        >
          <DeleteCommonModal
            handleClose={() => setIsDeleteModalOpen(false)}
            title='Delete Contact'
            paragraph='Are you sure you want to delete this contact? This action cannot be undone.'
            handleDelete={async () => {
              await BiteDBAPI.deleteDatabase(deleteId);
              setDeleteId('');
              setIsDeleteModalOpen(false);
              refetchDbs();
            }}
          />
        </Modal>

        {showAddProductModal && (
          <AddProductModal
            open={showAddProductModal}
            handleClose={handleAddProductModalClose}
            title={
              parent?.name ? `Add Product to ${parent?.name}` : 'Add Product'
            }
            database={{ id: parent?.database_id || '-1' }}
            handleRefresh={refetchProducts}
            parentId={parent?.id || null}
          />
        )}
        <Modal
          open={editProductClassifyOpen}
          onClose={setEditProductClassifyOpen}
        >
          <Classification
            handleClose={() => setEditProductClassifyOpen(false)}
            handleRefresh={refetchProducts}
            product={editProductItem}
          />
        </Modal>
        <Modal
          open={isDeletingItems}
          onClose={() => {
            setIsDeletingItems(false);
          }}
        >
          <DeleteCommonModal
            handleClose={() => {
              setIsDeletingItems(false);
            }}
            handleDelete={handleDeleteProduct}
            title={`Delete product from the database?`}
            paragraph={
              'Once deleted there is no way to recover these items in both the database and or in either product tab view or the product tab view.'
            }
            isLoading={false}
          />
        </Modal>
      </div>
    </DBModuleHeaderLayout>
  );
};

export default ProductsComponent;
